module.exports = __webpack_public_path__ + "img/boissonschaudes.a4d49539.png";